module.exports = __webpack_public_path__ + "img/new_seal_get.74b4ebb2.png";